import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { APP_INITIALIZER } from '@angular/core';
import { KeycloakBearerInterceptor, KeycloakService } from 'keycloak-angular';
import { initializeKeycloak } from '../../init/keycloak-init';
import { CacheHttpInterceptor } from './cache-http.interceptor';
import { ErrorHandlerInterceptor } from './error-handler.interceptor';
import { LanguageInterceptor } from './language.interceptor';
import { LoadingInterceptor } from './loading.interceptor';
import { DelegationInterceptor } from './delegation.interceptor';

export const httpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LoadingInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorHandlerInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LanguageInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: CacheHttpInterceptor,
    multi: true,
  },
  {
    provide: APP_INITIALIZER,
    useFactory: initializeKeycloak,
    multi: true,
    deps: [KeycloakService],
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: KeycloakBearerInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: DelegationInterceptor,
    multi: true,
  },
];
